import React from "react";
import { Button, Table } from "react-bootstrap";

import {
  formatCount,
  formatCurrency,
  formatDate,
  formatTime,
  getPersonName,
} from "./paymentReportUtils";

const StatusBadge = ({ status }) => {
  const normalizedStatus = String(status || "unpaid").toLowerCase();
  const isPaid = normalizedStatus === "paid";

  return (
    <span
      className={`consultation-payment-status consultation-payment-status--${
        isPaid ? "paid" : "unpaid"
      }`}
    >
      <span className="consultation-payment-status__dot" aria-hidden="true" />
      {isPaid ? "Paid" : "Unpaid"}
    </span>
  );
};

const ConsultationTable = ({
  bulkUpdating = false,
  consultations,
  doctorName,
  onPaymentAction,
  onSelectionChange,
  selectedPaymentIds = [],
  updatingPaymentIds = [],
}) => {
  const rows = Array.isArray(consultations) ? consultations : [];

  if (!rows.length) {
    return (
      <div className="consultation-payment-nested-empty">
        No consultations were returned for this doctor in the selected date range.
      </div>
    );
  }

  return (
    <div className="consultation-payment-nested-table-wrap">
      <Table className="consultation-payment-nested-table">
        <thead>
          <tr>
            <th className="consultation-payment-nested-table__select-cell">
              <span className="sr-only">Select consultation</span>
            </th>
            <th>Consultation date</th>
            <th>Patient name</th>
            <th>First call</th>
            <th>Last call</th>
            <th>Call attempts</th>
            <th>Gross fee</th>

            <th>Net payment</th>
            <th>Status</th>
            <th>Payment action</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((consultation, index) => {
            const isPaid =
              String(consultation.payment_status || "").toLowerCase() === "paid";
            const rowKey =
              consultation.payment_id ||
              consultation.logical_consultation_id ||
              `${consultation.date || "consultation"}-${index}`;
            const paymentId = String(consultation.payment_id || "");
            const isUpdating = updatingPaymentIds.indexOf(paymentId) >= 0;


            return (
              <tr key={rowKey}>
                <td className="consultation-payment-nested-table__select-cell">
                  <input
                    type="checkbox"
                    checked={selectedPaymentIds.indexOf(paymentId) >= 0}
                    onChange={() => onSelectionChange(paymentId)}
                    disabled={!paymentId || isUpdating || bulkUpdating}
                    aria-label={`Select consultation for ${getPersonName(
                      consultation.patient,
                      "patient",
                    )} on ${formatDate(consultation.date)}`}
                  />
                </td>
                <td>{formatDate(consultation.date)}</td>
                <td>
                  <strong>{getPersonName(consultation.patient)}</strong>
                </td>
                <td>{formatTime(consultation.first_call_time)}</td>
                <td>{formatTime(consultation.last_call_time)}</td>
                <td>{formatCount(consultation.call_attempt_count)}</td>
                <td>{formatCurrency(consultation.gross_fees)}</td>

                <td>
                  <strong>{formatCurrency(consultation.doctor_net_payment)}</strong>
                </td>
                <td>
                  <StatusBadge status={consultation.payment_status} />
                </td>
                <td>
                  {consultation.has_linked_appointment === false ? (
                    <span className="consultation-payment-link-warning">
                      No linked completed appointment
                    </span>
                  ) : null}
                  {consultation.payment_id ? (
                    <Button
                      bsStyle={isPaid ? "warning" : "success"}
                      bsSize="small"
                      className="consultation-payment-action-button btn-fill"
                      disabled={isUpdating || bulkUpdating}
                      onClick={() =>
                        onPaymentAction({
                          action: isPaid ? "unpaid" : "paid",
                          consultation,
                          doctorName,
                        })
                      }
                    >
                      {isUpdating ? (
                        <span>
                          <i className="fa fa-spinner fa-spin" aria-hidden="true" /> Updating…
                        </span>
                      ) : isPaid ? (
                        "Mark as Unpaid"
                      ) : (
                        "Mark as Paid"
                      )}
                    </Button>
                  ) : consultation.has_linked_appointment !== false ? (
                    <span className="consultation-payment-cell-note">
                      Payment action unavailable
                    </span>
                  ) : null}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export { StatusBadge };
export default ConsultationTable;
